export const SET_WELCOME_USER_INITIALIZE_COMPLETE = "SET_WELCOME_USER_INITIALIZE_COMPLETE";
export const FORCE_IS_ACTIVE_SESSION = "FORCE_IS_ACTIVE_SESSION";
export const ALTER_DISABLED_STATUS_OF_INPUTBOX = "ALTER_DISABLED_STATUS_OF_INPUTBOX";



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/appevent-welcomeuser-onlaunch/src/actions/actionTypes.ts